<div class="output-card">
    <span class="output-name">{{ output.name }}</span>
    <span class="output-timer" *ngIf="output.timer > 0">{{ 'output.timer' | translate: { seconds: output.timer } }}</span>
    <div class="output-actions">
      <button class="edit-button" (click)="onEdit()">
        <img src="assets/icons/edit.svg" width="20" height="20" [alt]="'common.edit' | translate" />
      </button>
      <label class="switch" (click)="$event.stopPropagation()">
        <input
          type="checkbox"
          [checked]="outputChecked"
          (click)="onToggle($event)"
        />
        <span class="slider"></span>
      </label>
    </div>
</div>
